import React from "react";
import { withStyles } from "@mui/styles";
import { Dialog, DialogContent, Box, useMediaQuery } from "@mui/material";
import { useWeb3React } from "@web3-react/core";
import theme from "./theme";
const StyledModal = withStyles(() => ({
  root: {
    "& .MuiDialog-root": {
      zIndex: "1301 !important",
    },
    "&.MuiDialog-container": {
      overflowY: "hidden !important",
    },
    "& .MuiDialog-paperScrollPaper": {
      backgroundColor: "tranparent !important",
      height: "auto",

      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      // borderRadius: "30px !important",
    },
    "& .dialoge__content__section": {
      background: "#000A19",
      // border: "1px solid #f1f5f91f",
      // borderRadius: 5,
    },
    "& .MuiDialogContent-root": {
      padding: "0px",
    },
  },
}))(Dialog);

function LogoutModal({ openLogout, setopenLogout }) {
  const { account, deactivate } = useWeb3React();
  const matches = useMediaQuery("(max-width:760px)");
  const handleClose = () => {
    setopenLogout(false);
  };

  return (
    <>
      <StyledModal
        keepMounted
        open={openLogout}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent className="dialoge__content__section">
          <div
            style={{
              textAlign: "center",
              paddingBottom: "30px",
              width: matches ? "auto" : "500px",
            }}
          >
            <Box
              style={{
                background:
                  "linear-gradient(94.25deg, #EEBE62 0%, #9C702A 31.82%, #EEBE62 75.71%, #9C702A 98%)",
              }}
              display="flex"
              px={2}
              py={2}
              justifyContent="space-between"
            >
              <Box
                color={theme.modalColors.textColor}
                fontSize="20px"
                textAlign="left"
                fontWeight="600"
                fontFamily="Segoe UI"
              >
                Your Wallet
              </Box>
              <Box>
                <i
                  onClick={handleClose}
                  style={{
                    color: theme.modalColors.textColor,
                    textAlign: "right",
                    fontSize: "25px",
                    cursor: "pointer",
                  }}
                  class="fal fa-times"
                ></i>
              </Box>
            </Box>
            <Box mt={2}>
              <img width="100px" src="/logo.png" alt="" />
            </Box>
            <Box
              px={2}
              borderRadius="10px"
              color="#ffffff"
              fontSize={matches ? "12px" : "17px"}
              textAlign="center"
              fontWeight={matches ? "400" : "600"}
              fontFamily="Segoe UI"
            >
              {account}
            </Box>
            {/* <Box
              paddingLeft="20px"
              paddingRight="20px"
              mt={3}
              mb={5}
              display="flex"
              alignItems="center"
              justifyContent="space-evenly"
              flexWrap="wrap"
            >
              <a
                href={bscScan}
                target="_blank"
                style={{
                  cursor: "pointer",
                  color: "#ff40a9f2",
                  fontFamily: "Segoe UI",
                  fontSize: "17px",
                  fontWeight: "600",
                  borderRadius: "10px",
                  padding: "5px 10px",
                  textDecoration: "none",
                }}
              >
                View On BscScan
                <i
                  style={{
                    color: "#ff40a9f2",
                    textAlign: "right",
                    fontWeight: "500",
                    fontSize: "20px",
                    cursor: "pointer",
                    marginLeft: "10px",
                  }}
                  class="fal fa-external-link"
                ></i>
              </a>

              <CopyToClipboard
                style={{ cursor: "pointer" }}
                text={account ? account : ""}
                onCopy={() => {
                  account
                    ? toast.success("Wallet Address copied!", {
                        icon: <img width="20px" src={logoBull} />,
                      })
                    : toast.error("Error! Please connect your wallet!", {
                        icon: <img width="20px" src={logoBull} />,
                      });
                }}
              >
                <Box
                  marginTop={matches ? "10px" : "0px"}
                  color="#ff40a9f2"
                  fontFamily="Segoe UI"
                  fontSize="17px"
                  fontWeight="600"
                  borderRadius="10px"
                  padding="5px 10px"
                  style={{ cursor: "pointer" }}
                >
                  Copy Address
                  <i
                    style={{
                      color: "#ff40a9f2",
                      textAlign: "right",
                      fontWeight: "500",
                      fontSize: "20px",
                      cursor: "pointer",
                      marginLeft: "10px",
                    }}
                    class="fal fa-copy"
                  ></i>
                </Box>
              </CopyToClipboard>
            </Box> */}
            <Box display="flex" justifyContent="center">
              <Box
                mt={2}
                mx={3}
                borderRadius="10px"
                style={{
                  background:
                    "linear-gradient(94.25deg, #EEBE62 0%, #9C702A 31.82%, #EEBE62 75.71%, #9C702A 98%)",
                  cursor: "pointer",
                }}
                paddingTop="10px"
                paddingBottom="10px"
                fontFamily="Segoe UI"
                fontSize="18px"
                fontWeight="600"
                width="50%"
                color={theme.modalColors.textColor}
                onClick={() => {
                  deactivate();
                  localStorage.removeItem("wallet");
                  // window.localStorage.removeItem(connectorLocalStorageKey);
                  handleClose();
                }}
              >
                Logout
              </Box>
            </Box>
          </div>
        </DialogContent>
      </StyledModal>
    </>
  );
}
export default LogoutModal;
